import React, { Component } from "react";

class LoginInput extends Component {
   constructor(props) {
      super(props);

      // reset login status
      // this.props.logout();

      this.state = {
         username: "",
         password: "",
         autologin: this.props.autologin || false,
      };

      this.handleChange = this.handleChange.bind(this);
      this.toggleChange = this.toggleChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
   }

   handleChange(e) {
      const { name, value } = e.target;
      this.setState({ [name]: value });
   }

   toggleChange() {
      const { autologin } = this.state;
      this.setState({
         autologin: !autologin,
      });

      this.props.onToggleChange(!autologin);
   }

   handleSubmit(e) {
      e.preventDefault();
      const { username, password, autologin } = this.state;
      if (username && password) {
         this.props.login(username, password, autologin);
      }
   }

   LoadingSpinner = () => {
      return (
         <div className="spinner-container">
            ログイン中
            <span className="loading-spinner"></span>
         </div>
      );
   };

   render() {
      const { username, password, autologin } = this.state;
      const { isFetching = false } = this.props;
      return (
         /*<div
                className="row col-md-6 offset-md-3"
                style={{ marginTop: '20px', align: 'center' }}
            >*/
         <div>
            <form name="form" onSubmit={this.handleSubmit}>
               <div className="form-group input-field">
                  <label
                     className="label-control rounded-0"
                     name="lbl_username"
                     style={{ textAlign: "left" }}
                  >
                     ログインＩＤ
                  </label>
                  <input
                     type="text"
                     className="form-control rounded-0"
                     name="username"
                     id="inputUsername"
                     value={username}
                     onChange={this.handleChange}
                     aria-describedby="emailHelp"
                     placeholder="ログインＩＤ"
                     autoComplete="on"
                     required
                     autoFocus
                     disabled={isFetching}
                  />
               </div>
               <div className="form-group input-field">
                  <label
                     className="label-control rounded-0"
                     name="lbl_password"
                     style={{ textAlign: "left" }}
                  >
                     パスワード
                  </label>
                  <input
                     type="password"
                     className="form-control rounded-0"
                     name="password"
                     id="inputPassword"
                     value={password}
                     onChange={this.handleChange}
                     placeholder="パスワード"
                     required
                     disabled={isFetching}
                  />
               </div>

               <div style={{ textAlign: "left" }}>
                  <input
                     type="checkbox"
                     className="chkautologin"
                     name="autologin"
                     id="inputAutoLogin"
                     defaultChecked={autologin}
                     onChange={this.toggleChange}
                  />
                  <label htmlFor="inputAutoLogin">
                     {" "}
                     次回から自動的にログインする
                  </label>
                  <br />
               </div>
               <button
                  className="btn btn-custom signin"
                  disabled={this.props.isFetching}
               >
                  {isFetching === false ? "ログイン" : this.LoadingSpinner()}
               </button>
               <label
                  className="label-control rounded-0 copyright"
                  style={{ textAlign: "center" }}
               >
                  © HAKARU PLUS CORPORATION All Right Reserved.
               </label>
            </form>
         </div>
      );
   }
}

export default LoginInput;
